module.exports = __webpack_public_path__ + "img/1.11.2_Russian_road_sign.cd91a986.svg";